import React, { useState } from 'react'
import classnames from 'classnames'
import moment from 'moment-timezone'
import { Button, Alert, Intent, Classes } from '@blueprintjs/core'
import FixedRatioResponsiveContainer from '../../layout/fixed-ratio-responsive-container/fixed-ratio-responsive-container'
import { serverErrorToast, successToast } from '../../layout/toaster/toaster'
import { packsApi } from '../../../api'
import authentication from '../../../authentication'
import PackHeader from './pack-header'
import PackBody from './pack-body'
import css from './styles.module.css'

function Card ({ status, isConnected, children }) {
  const statusClasses = {
    [css.notMonitored]: !isConnected,
    [css.active]: status === 'active'
  }
  return <div className={classnames(css.card, statusClasses)}>{children}</div>
}

function Pack ({ pack, options = {}, onDelete }) {
  const [isDeletePackOpen, setIsDeletePackOpen] = useState(false)
  const [isDeletePackWaiting, setIsDeletePackWaiting] = useState(false)
  const timezone = options.timezone || moment.tz.guess()
  const { status, isConnected, packId, startDate, endDate, cavities } = pack
  const { role } = authentication.authenticationData

  async function handleDelete () {
    setIsDeletePackWaiting(true)
    setIsDeletePackOpen(false)
    try {
      await packsApi.delete(pack._id)
      successToast('Pack successfully deleted.')
      onDelete()
    } catch (err) {
      serverErrorToast(err)
    }
    setIsDeletePackWaiting(false)
  }

  if (!pack) return null
  if (isDeletePackWaiting) {
    return (
      <FixedRatioResponsiveContainer width='100%' maxWidth='550px' minWidth='445px' heightOverWidthRatio={1.5}>
        <div className={Classes.SKELETON} style={{ width: '100%', height: '100%' }} />
      </FixedRatioResponsiveContainer>
    )
  }

  return (
    <FixedRatioResponsiveContainer width='100%' maxWidth='550px' minWidth='445px' heightOverWidthRatio={1.5}>
      <Alert
        cancelButtonText='Cancel'
        confirmButtonText='Remove'
        icon='trash'
        intent={Intent.DANGER}
        isOpen={isDeletePackOpen}
        onCancel={() => setIsDeletePackOpen(false)}
        onConfirm={handleDelete}
      >
        <p>Are you sure you want to remove this pack?</p>
      </Alert>
      <div className={css.container}>
        <div className={css.packId}>ID: {packId}</div>
        <Card status={status} isConnected={isConnected}>
          {['pharmacy', 'admin'].includes(role) && <Button icon='trash' style={{ zIndex: 10, alignSelf: 'flex-end' }} minimal onClick={() => setIsDeletePackOpen(true)} />}
          <PackHeader startDate={startDate} endDate={endDate} timezone={timezone} isConnected={isConnected} status={status} />
          <PackBody cavities={cavities} startDate={startDate} timezone={timezone} />
        </Card>
      </div>
    </FixedRatioResponsiveContainer>
  )
}

export default Pack
